export default __webpack_public_path__ + "static/media/virgin-logo.53fd4556.svg";